import { useEffect, useRef } from 'react';

import { MessagingChannel } from '~hooks/useMessaging/models';
import useMessagingChannelTypers from '~hooks/useMessaging/useMessagingChannelTypers';
import { Nullable } from '~types/Nullable';

export default function useMessagingChannelRowTypers({
  channel,
  isOnScreen,
  viewerUserId,
}: {
  channel: MessagingChannel;
  isOnScreen: boolean;
  viewerUserId: Nullable<string>;
}) {
  const { dropTyper, typers } = useMessagingChannelTypers({
    channelId: isOnScreen ? channel.id : null,
    viewerUserId,
  });
  const lastMessage = channel.lastMessage;
  const previousLastMessageIdRef = useRef(lastMessage?.id);

  useEffect(() => {
    if (lastMessage?.id === previousLastMessageIdRef.current) return;
    previousLastMessageIdRef.current = lastMessage?.id;

    const senderId = lastMessage?.senderId;
    if (senderId) dropTyper(senderId);
  }, [dropTyper, lastMessage]);

  return typers;
}
